import { get } from 'lodash';
import { ThunkAction } from 'redux-thunk';
import { AnyAction } from '@reduxjs/toolkit';
import apolloClient from '@src/graphql/apollo';
import { trackPageView, trackRegister } from '@src/metrics';
import store from '@src/redux';
import { CustomerDocument, CustomerQuery, LogoutMutation, SessionQuery, LogoutDocument } from '@src/graphql/generated';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { captureError } from '@src/util/error';
import { removeAccessToken } from '../accessToken';
import { RecruiterActions } from './recruiter.enum';
import { FetchCustomerStatusAction, SetRecruiterAction } from './recruiter.interface';

export function setRecruiter(
  recruiter: SessionQuery['currentRecruiter'],
): ThunkAction<void, RootState, unknown, SetRecruiterAction> {
  return dispatch => {
    trackPageView({ pagePath: window.location.pathname });

    trackRegister({
      email: recruiter.email || undefined,
      id: recruiter.id,
      name: recruiter.fullName || undefined,
      registeredCountryId: get(recruiter, 'country.id'),
    });

    dispatch({
      payload: recruiter,
      type: RecruiterActions.RECRUITER_SET,
    });
  };
}

export function fetchCustomerStatus(): ThunkAction<void, RootState, unknown, FetchCustomerStatusAction> {
  return async dispatch => {
    const {
      data: { customer },
    } = await apolloClient.query<CustomerQuery>({ query: CustomerDocument });

    dispatch({
      status: customer,
      type: RecruiterActions.CUSTOMER_STATUS_FETCHED,
    });

    return customer;
  };
}

export const LOG_OUT = `${__dirname}/logOut`;
export function logout(): ThunkAction<void, RootState, unknown, AnyAction> {
  return async dispatch => {
    try {
      await apolloClient.mutate<LogoutMutation>({
        mutation: LogoutDocument,
      });
      dispatch(removeAccessToken());
    } catch (error) {
      captureError(error);

      dispatch(removeAccessToken());
    }

    return {
      type: LOG_OUT,
    };
  };
}

// expose it to window so we could call it inside iframe
window.fetchCustomerStatus = function () {
  store.dispatch(fetchCustomerStatus());
};
